var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"button",on:{"click":function($event){return _vm.createPDF()}}},[_vm._v("\n    "+_vm._s(_vm.$t("insight.exporter_pdf"))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }